import loadable from '@loadable/component';
import Loading from '../../components/Loader';

export const CreateJobForm = loadable(
  () => import(/* webpackChunkName: "doe-create-job-form" */ '../../pages/Doe/CreateJobForm'),
  {
    fallback: Loading,
  }
);
